import React from 'react';
import Styles from './styles.module.css';

type DefaultDescProps = {
  text: string;
  type?: "warning" | "error";
  error?: boolean;
};

const DefaultDesc: React.FC<DefaultDescProps> = ({ text, type, error}) => {

  return (
    <>
    {type === undefined ?
      <p className={Styles.desc}>{text}</p>
    : type === "warning" ?
      <p className={Styles.desc} style={error ? { color: "#F2941A", fontWeight: "bold" } : {}}>{text}</p>
    : type === "error" ?
      <p className={Styles.desc} style={error ? { color: "var(--mw-error)", fontWeight: "bold" } : {}}>{text}</p>
    : <></> }
    </>
  );
}

export default DefaultDesc;
